export default {"src":"/_next/static/media/quotes.1518235c.svg","height":87,"width":116,"blurWidth":0,"blurHeight":0};